import { NgModule } from '@angular/core';
import { SavedTageFiltersComponentModule, TageFilterComponentModule, TageListComponentModule, TageSorterComponentModule } from '.';

@NgModule({
  imports: [TageFilterComponentModule, TageListComponentModule, TageSorterComponentModule, SavedTageFiltersComponentModule],
  exports: [TageFilterComponentModule, TageListComponentModule, TageSorterComponentModule, SavedTageFiltersComponentModule],
})
export class TageQueryModule {}
